export function add<T>(list: T[], item: T, index?: number): T[] {
  const result = Array.from(list)
  result.push(item)
  return typeof index !== 'undefined' && index >= -1
    ? reorder(result, result.length - 1, index + 1)
    : result
}

export function remove<T>(list: T[], index: number): T[] {
  const result = Array.from(list)
  result.splice(index, 1)
  return result
}

export function update<T>(list: T[], field: T, index: number): T[] {
  const result = Array.from(list)
  result.splice(index, 1)
  result.splice(index, 0, field)
  return result
}

export function reorder<T>(list: T[], startIndex: number, endIndex: number): T[] {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)
  return result
}
